import Promise from 'promise';
import Axios from "axios";
import { axios, CommonHelper } from '../_helpers';

export const FavoriteService = {
    toggleFavorite,
    getFavoriteVideos
};

//this service is used for add or remove favourite
function toggleFavorite(favorite) {
    return new Promise(function (resolve, reject) {
        axios.post('toggleVideoFavorite', { ...favorite }).then((res) => {
            if (res.isSuccess) {
                resolve(res);
            } else {
                reject(res.message);
            }
        }).catch(error => {
            reject(error.message);
        });
    })
};

//this service is used for get user favourite videos
function getFavoriteVideos(userId, bookId) {
    return new Promise(function (resolve, reject) {
        axios.post('getFavoriteVideos', { userId, bookId }).then((res) => {
            if (res.isSuccess) {
                resolve(res.data);
            } else {
                reject(res.message);
            }
        }).catch(error => {
            reject(error.message);
        });
    })
};



// WEBPACK FOOTER //
// ./src/_services/favourite.service.js